import { IState } from './index';
import { ActionTree } from 'vuex';
import { IStore } from "../index";
import { FunnelEvent } from "@store/funnel/interfaces/funnelEvent";
import { EcommerceItem } from "@store/funnel/interfaces/ecommerceItem/ecommerceItem";
import { GtmData } from "@store/funnel/interfaces/gtmData";
import { createEcommerceItemFromTeaserItem } from "@store/funnel/factory/EcommerceItemFactory";
import { TeaserItem } from "@store/funnel/interfaces/teaserItem";
import { TeaserListFunnelEvent } from "@store/funnel/interfaces/teaserListFunnelEvent";
import { AddPaymentInfoEvent } from "@store/funnel/interfaces/addPaymentInfoEvent";
import { pushToDataLayer } from "@lib/gtm/dataLayer";
import LocalStorageWithFallback from "@lib/cookieMessage/localStorageWithFallback";
import { LOCAL_STORAGE_KEY_CHECKOUT_FUNNEL } from "@constants/event";

export default {
    initEcommerceItem({ state, rootState, commit }, gtmData: GtmData) {
        commit('addGtmData', gtmData);

        if (rootState.dateAndPrice.isInCheckout) {
            commit('addFareToDataLayer', rootState.checkout.fare);
        }
    },
    pushEventDataLayer({ state, rootState, commit }, { eventName, extraData, price, appointment }) {
        const ecommerceItem: EcommerceItem = { ...state.ecommerceItem };

        ecommerceItem.price = price !== 0 && price !== undefined
            ? price
            : rootState.checkout.priceSummary.totalPrice;

        const appointmentId: string = rootState.dateAndPrice.isInCheckout
            ? rootState.checkout.checkoutSettings.appointmentHash
            : (appointment ?? '');

        ecommerceItem.currency = rootState.checkout.priceSummary.currency;

        const eventObject: FunnelEvent = {
            event: eventName,
            appointmentId: appointmentId,
            locale: rootState.checkout.checkoutSettings.locale,
            ecommerce: {
                items: [ecommerceItem]
            }
        };

        pushToDataLayer({ ...eventObject, ...extraData });
    },
    pushSpecialEventDataLayer({ state }, { eventName, price, paymentType, coupon }) {
        const ecommerceItem: EcommerceItem = { ...state.ecommerceItem };

        const currency = ecommerceItem.currency;
        delete ecommerceItem.item_list_id;
        delete ecommerceItem.item_list_name;
        delete ecommerceItem.currency;

        ecommerceItem.price = price;
        ecommerceItem.coupon = coupon;
        const eventObject: AddPaymentInfoEvent = {
            event: eventName,
            ecommerce: {
                coupon: coupon,
                currency: currency,
                payment_type: paymentType,
                value: price,
                items: [ecommerceItem]
            }
        };

        pushToDataLayer(eventObject);
    },
    createTeaserListFunnelEvent({ state }, { event, itemListId, itemListName, items, tripTeaserItemIndex = 0 }): TeaserListFunnelEvent {
        const ecommerceItems = [];
        const teaserListFunnelEvent: TeaserListFunnelEvent = {
            event: event,
            ecommerce: {
                item_list_id: itemListId,
                item_list_name: itemListName,
                items: []
            }
        }
        let index: number = 0;
        for (const item of items as TeaserItem[]) {
            if (tripTeaserItemIndex !== 0) {
                index = tripTeaserItemIndex;
            }
            ecommerceItems.push(createEcommerceItemFromTeaserItem(item, index));
            index++;
        }

        teaserListFunnelEvent.ecommerce.items = ecommerceItems;

        return teaserListFunnelEvent
    },
    addSelectedToCheckoutFunnel({ commit }, { type, picked }) {
        commit('updateCheckoutFunnel', { type, picked });
    },
    saveCheckoutFunnelOnDevice({ state }) {
        const localStorageWithFallback= new LocalStorageWithFallback();

        localStorageWithFallback.set(LOCAL_STORAGE_KEY_CHECKOUT_FUNNEL, JSON.stringify(state.checkoutFunnel));
    }
} as ActionTree<IState, IStore>
